export const UPDATE_GAME_STATE = "UPDATE_GAME_STATE";
export const CLEAR_PLAYERS_IN_GAME_STATE = "CLEAR_PLAYERS_IN_GAME_STATE";
